import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HeroSliderRevamp from "./component";
import { withRouter } from "react-router-dom";
import { setFomoNudgeData } from "../car-details/actions";
const mapStateToProps = ({
    carDetails: {
        content,
        config: { imageHost, brandImageHost } = {},
        fomoData,
        carSeenCount
    },
    abExperiment: {
        desktopWishlistAdoption,
        desktopPremiumFeatures,
        hideImperfectionsDesktop
    },
    user: {
        isLoggedIn
    }
}) => ({
    content,
    imageHost,
    desktopPremiumFeatures,
    fomoData,
    desktopWishlistAdoption,
    carSeenCount,
    isLoggedIn,
    brandImageHost,
    hideImperfectionsDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setFomoNudgeDataConnect: setFomoNudgeData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeroSliderRevamp));
